import { LOAD_TABLE } from "../types/type"

export const setLoadTable = (tableData) => {
    return ({
        type: LOAD_TABLE,
        payload: tableData
    })
}